import React from 'react';
import { BANNER_URL } from '../../lib/constants';

const Header = () => (
  <header data-testid="site-header" className="w-full bg-[#F7EFD9]">
    <div className="mx-auto max-w-[1280px]">
      <a href="/" data-testid="logo-link" className="block">
        <img
          src={BANNER_URL}
          alt="Omvedha — Rooted in Tradition; Delivered with Trust. Pooja Services, Astrology, Vastu, Numerology, Gemstones, Ritual Essentials, Pooja Essentials."
          className="block h-auto w-full"
          loading="eager"
        />
      </a>
    </div>
  </header>
);

export default Header;
